import Icon from "@/icon";
import { useAppTheme } from "@/theme";
import {
  Badge,
  Box,
  CardContent,
  Paper,
  PaperProps,
  Typography,
  styled,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const How = () => {
  const { t } = useTranslation();
  const theme = useAppTheme();

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"center"}
      gap={4}
    >
      <Box>
        <Typography
          variant={"h4"}
          textAlign={"center"}
          fontWeight={theme.typography.fontWeightBold}
        >
          {t("how.title")}
        </Typography>
        <Typography
          variant={"h6"}
          textAlign={"center"}
          sx={{ color: theme.palette.primary.main, opacity: 0.38 }}
        >
          {t("how.subtitle")}
        </Typography>
      </Box>
      <Box display={"flex"} flex={1} flexDirection={"column"}>
        <StyledPaper theme={theme}>
          <StyledCardContent>
            <Box
              p={1}
              sx={{
                outlineWidth: 1,
                outlineColor: theme.palette.primary.main,
                outlineStyle: "solid",
              }}
              borderRadius={theme.shape.borderRadius}
              position={"relative"}
            >
              <Icon
                icon={"download"}
                size={24}
                color={theme.palette.primary.main}
              />
              <Badge
                sx={{ position: "absolute", bottom: 4, right: 4 }}
                badgeContent={1}
                color={"primary"}
              />
            </Box>
            <Box>
              <Typography
                variant={"h6"}
                fontWeight={theme.typography.fontWeightBold}
              >
                {t("how.install.title")}
              </Typography>
              <Typography component={"p"}>
                {t("how.install.subtitle")}
              </Typography>
            </Box>
          </StyledCardContent>
        </StyledPaper>
        <StyledPaper theme={theme}>
          <StyledCardContent>
            <Box
              p={1}
              sx={{
                outlineWidth: 1,
                outlineColor: theme.palette.primary.main,
                outlineStyle: "solid",
              }}
              borderRadius={theme.shape.borderRadius}
              position={"relative"}
            >
              <Icon
                icon={"chevrons-right"}
                size={24}
                color={theme.palette.primary.main}
              />
              <Badge
                sx={{ position: "absolute", bottom: 4, right: 4 }}
                badgeContent={2}
                color={"primary"}
              />
            </Box>
            <Typography
              variant={"h6"}
              fontWeight={theme.typography.fontWeightBold}
            >
              {t("how.continuous-learning.title")}
            </Typography>
            <Typography component={"p"}>
              {t("how.continuous-learning.subtitle")}
            </Typography>
          </StyledCardContent>
        </StyledPaper>
        <StyledPaper theme={theme}>
          <StyledCardContent>
            <Box
              p={1}
              sx={{
                outlineWidth: 1,
                outlineColor: theme.palette.primary.main,
                outlineStyle: "solid",
              }}
              borderRadius={theme.shape.borderRadius}
              position={"relative"}
            >
              <Icon
                icon={"ask-sent"}
                size={24}
                color={theme.palette.primary.main}
              />
              <Badge
                sx={{ position: "absolute", bottom: 4, right: 4 }}
                badgeContent={3}
                color={"primary"}
              />
            </Box>
            <Typography
              variant={"h6"}
              fontWeight={theme.typography.fontWeightBold}
            >
              {t("how.ask-your.title")}
            </Typography>
            <Typography component={"p"}>
              {t("how.ask-your.subtitle")}
            </Typography>
          </StyledCardContent>
        </StyledPaper>
      </Box>
    </Box>
  );
};

const StyledCardContent = styled(CardContent)({
  textAlign: "center",
  gap: 4,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const StyledPaper = styled((props: PaperProps) => (
  <Paper {...props} elevation={0} />
))(({ theme }) => ({
  flex: 1,
  borderRadius: theme.shape.borderRadius * 4,
  background: "transparent",
}));

export default How;
